import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import { styled, superstyled } from '@zenbusiness/zui/styles';

export const CardList = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),

  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
  },
}));

export const ContentContainer = superstyled({
  tag: Box,
  name: 'ProductCategories',
  slot: 'ContentContainer',
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  }),
});

export const CardItem = superstyled({
  name: 'CardItem',
  slot: 'CardItem',
  tag: Card,
  propsAdded: {
    size: 'lg',
  },
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
  }),
});
